import React from 'react';
import { useTranslation } from 'react-i18next';

export const ModalBodyPhoneIsRequired = () => {
  const { t } = useTranslation();

  return <p className="text-xs font-light" dangerouslySetInnerHTML={{ __html: t('cant-take-application') }} />;
};
